'use strict';

(function () {
  'use strict';

  angular.module('vnext').service('searchPageSvc', searchPageSvc);

  searchPageSvc.$inject = ['httpSvc'];

  /* @ngInject */
  function searchPageSvc(httpSvc) {
    return {
      getCategories: getCategories,
      findPage: findPage,
      filterFilters: filterFilters,
      loadChannelActivities: loadChannelActivities
    };

    ////////////////

    /**
     * Get all of the search pages cateogries
     * @return {List} This is an array of all the categories that exist. Each category will also have a list of pages
     */
    function getCategories() {
      return httpSvc.get('/apiproxy/user/searchpage');
    }
    /**
     * Find a specific page in some category. This filters through all the categories looking for the specified page.
     * @param  {Integer} pageId     The ID of the page to find
     * @param  {List} allCategories The list of categories that should contain the given page
     * @return {Page}               The page, or undefined it it wasn't found
     */
    function findPage(pageId, allCategories) {
      return allCategories.reduce(function (prev, cur) {
        return prev || cur.pages.filter(function (page) {
          return page.id === pageId;
        })[0];
      }, null);
    }
    /**
     * Filter a list of filters down to only the filters that could actually be applied to the given list of activities
     * @param  {Array} filters    A list of filters to reduce
     * @param  {Array} activities The list of activities to compare the filters to.
     * @return {Array} filters    An array containing only the filters than can be applied to the given activities
     */
    function filterFilters(filters, activities) {
      // This will probably need to be rewritten - but this removes any filtering that would result in an empty list
      // This only checks the first filter in the filters list
      return [filters[0].filter(function (filter) {
        // look through all the activities to see if they're tagged with this filter
        return activities.filter(function (activity) {
          // check all the activity's tags to see if they match the filter
          return activity.tags.filter(function (tag) {
            return filter.tag === tag.shortName;
          }).length > 0;
        }).length > 0;
      })];
    }

    function loadChannelActivities(pageTag, channel, limit) {
      var params;
      if (channel) {
        params = {
          tag: [channel.tag, pageTag],
          context: channel.validTypes.map(function (t) {
            return t.name;
          }),
          size: limit
        };
      } else {
        params = {
          tag: [pageTag],
          context: ['CORE', 'CORE_INSPIRATION', 'CORE_ARTICLE', 'ACTIVITY_PROGRAM', 'ACTIVITY_SERIES'],
          size: limit
        };
      }
      return httpSvc.get('/apiproxy/user/activities/search/tags/', {
        withCredentials: true,
        params: params
      });
    }
  }
})();